<svg [ngClass]='cssClasses' width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path
    d='M15.9301 3.59283C16.2809 3.24622 16.2809 2.66852 15.9301 2.33967L13.8253 0.259964C13.4924 -0.0866546 12.9078 -0.0866546 12.557 0.259964L10.9019 1.8864L14.275 5.21927L15.9301 3.59283ZM0 12.6671V16H3.37311L13.3215 6.16137L9.94842 2.8285L0 12.6671Z'
    fill='#3A4146' />
</svg>
